module.exports = __webpack_public_path__ + "img/VG.8c91bb9f.svg";